import { apiClient } from './client';
import type { LoginCredentials, User } from '@/types/models';
import type { TokenResponse } from '@/types/api';

export const authApi = {
  login: async (credentials: LoginCredentials): Promise<TokenResponse> => {
    const response = await apiClient.post<TokenResponse>(
      '/v1/auth/login',
      credentials,
    );
    return response.data;
  },

  refresh: async (refreshToken: string): Promise<TokenResponse> => {
    const response = await apiClient.post<TokenResponse>(
      '/v1/auth/refresh',
      { refresh_token: refreshToken },
    );
    return response.data;
  },

  logout: async (refreshToken: string): Promise<void> => {
    await apiClient.post('/v1/auth/logout', { refresh_token: refreshToken });
  },

  getMe: async (): Promise<User> => {
    const response = await apiClient.get<User>('/v1/auth/me');
    return response.data;
  },

  updateProfile: async (data: { phone?: string }): Promise<User> => {
    const response = await apiClient.patch<User>('/v1/auth/me', data);
    return response.data;
  },

  magicLink: async (token: string): Promise<TokenResponse> => {
    const response = await apiClient.post<TokenResponse>('/v1/auth/magic-link', { token });
    return response.data;
  },
};
